



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProductReport } from '@/interfaces/ProductReport';

@Component({
    name: 'AccountAddRecords',
})

export default class AccountAddRecords extends Vue {
    @Prop({
        required: true,
    }) protected isAddRecordsDialogVisible!: boolean;
    @Prop({
        required: true,
    }) protected addRecordsDialogData!: ProductReport[];
    protected checkList: ProductReport[] = [];
    protected isDisabled = false;

    protected closeDialog() {
        this.isDisabled = false;
        this.checkList = [];
        this.$emit('closeDialog', 'add');
    }

    protected onAddRecords() {
        this.isDisabled = true;
        this.$emit('addRecords', this.checkList.map((projects: ProductReport) => {
            if (!projects.brand) {
                return null;
            }
            return projects.brand.id;
        }));
    }
}
